/**
 * Dropdown list for time segment selection.
 *  */

import { forwardRef, useEffect, useRef } from 'react';
import { cn } from '@/lib/utils';

function pad(n: number) {
  return String(n).padStart(2, '0');
}

export const SegmentInput = forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  (props, ref) => (
    <input
      ref={ref}
      type="text"
      inputMode="numeric"
      {...props}
      className="w-7 bg-transparent text-center font-mono outline-none tabular-nums disabled:cursor-not-allowed"
    />
  ),
);

export function DropdownList({ items, selected, onSelect, align }: {
  items: number[];
  selected: number;
  onSelect: (v: number) => void;
  align: 'left' | 'right';
}) {
  const listRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = listRef.current?.querySelector('[data-active="true"]');
    el?.scrollIntoView({ block: 'center' });
  }, []);

  return (
    <div
      ref={listRef}
      className={cn(
        'absolute top-full z-50 mt-1 max-h-48 w-16 overflow-y-auto rounded-md border bg-popover p-1 shadow-md animate-in fade-in slide-in-from-top-2 duration-100',
        align === 'left' ? 'left-0' : 'right-0',
      )}
    >
      {items.map((val) => (
        <button
          key={val}
          type="button"
          data-active={val === selected}
          className={cn(
            'flex w-full items-center justify-center rounded-sm px-2 py-1 text-xs font-mono tabular-nums transition-colors hover:bg-accent hover:text-accent-foreground',
            val === selected && 'bg-primary text-primary-foreground',
          )}
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => onSelect(val)}
        >
          {pad(val)}
        </button>
      ))}
    </div>
  );
}
